import React, { useEffect, useState } from "react";
import { Box, Button, Divider, IconButton, Modal, TextField, Typography, } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import { useAddUsuarioPermiso } from "../../../hooks/AdministracionUsuarios/adminPermisosUsuarios/addUsuarioPermiso";

import { sanitizarNombrePermiso, sanitizarNombrePerfil, sanitizarDescripcionPerfil, validarNombrePerfil, validarDescripcionPerfil, } from "../../../utils/sanitizar";

interface AddAdminPermisoProps {
    open: boolean;
    onClose: () => void;
    onSuccess?: () => Promise<void> | void;
}

const AddAdminPermiso: React.FC<AddAdminPermisoProps> = ({
    open,
    onClose,
    onSuccess,
}) => {

    const {
        agregarPermiso,
        loading,
    } = useAddUsuarioPermiso();

    const [nombre, setNombre] = useState("");
    const [descripcion, setDescripcion] = useState("");
    const [sufijo, setSufijo] = useState("");

    const [errorNombre, setErrorNombre] = useState("");
    const [errorDescripcion, setErrorDescripcion] = useState("");
    const [errorSufijo, setErrorSufijo] = useState("");

    useEffect(() => {

        if (open) {
            limpiarFormulario();
        }

    }, [open]);

    const limpiarFormulario = () => {

        setNombre("");
        setDescripcion("");
        setSufijo("");

        setErrorNombre("");
        setErrorDescripcion("");
        setErrorSufijo("");

    };

    const cerrarModal = () => {

        limpiarFormulario();

        onClose();

    };

    const guardar = async () => {

        setErrorNombre("");
        setErrorDescripcion("");
        setErrorSufijo("");

        let existeError = false;

        if (!validarNombrePerfil(nombre)) {

            setErrorNombre("Ingresa un nombre válido.");

            existeError = true;

        }

        if (!validarDescripcionPerfil(descripcion)) {

            setErrorDescripcion(
                "Ingresa una descripción válida."
            );

            existeError = true;

        }

        if (!validarNombrePerfil(sufijo)) {

            setErrorSufijo(
                "Ingresa un sufijo válido."
            );

            existeError = true;

        }

        if (existeError) {
            return;
        }

        const response = await agregarPermiso({

            nombre: nombre.trim(),
            descripcion: descripcion.trim(),
            sufijo: sufijo.trim(),
            estatus: "1",

        });

        if (response) {

            await onSuccess?.();

            cerrarModal();

        }

    };

    return (

        <Modal
            open={open}
            onClose={cerrarModal}
        >

            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "90%",
                    maxWidth: 650,
                    bgcolor: "background.paper",
                    borderRadius: 2,
                    boxShadow: 24,
                    p: 3,
                }}
            >

                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={2}
                >

                    <Typography
                        variant="h6"
                        fontWeight="bold"
                    >
                        Agregar Permiso
                    </Typography>

                    <IconButton onClick={cerrarModal}>
                        <CloseIcon />
                    </IconButton>

                </Box>

                <Divider sx={{ mb: 3 }} />

                <Box
                    display="flex"
                    flexDirection="column"
                    gap={3}
                >

                    <TextField
                        fullWidth
                        label="Nombre"
                        value={nombre}
                        error={Boolean(errorNombre)}
                        helperText={errorNombre}
                        onChange={(e) => {

                            const value =
                                sanitizarNombrePermiso(
                                    e.target.value
                                );

                            setNombre(value);

                            if (
                                errorNombre &&
                                validarNombrePerfil(value)
                            ) {
                                setErrorNombre("");
                            }

                        }}
                    />

                    <TextField
                        fullWidth
                        multiline
                        minRows={3}
                        label="Descripción"
                        value={descripcion}
                        error={Boolean(errorDescripcion)}
                        helperText={errorDescripcion}
                        onChange={(e) => {

                            const value =
                                sanitizarDescripcionPerfil(
                                    e.target.value
                                );

                            setDescripcion(value);

                            if (
                                errorDescripcion &&
                                validarDescripcionPerfil(value)
                            ) {
                                setErrorDescripcion("");
                            }

                        }}
                    />

                    <TextField
                        fullWidth
                        label="Sufijo"
                        value={sufijo}
                        error={Boolean(errorSufijo)}
                        helperText={errorSufijo}
                        onChange={(e) => {

                            const value =
                                sanitizarNombrePerfil(
                                    e.target.value
                                );

                            setSufijo(value);

                            if (
                                errorSufijo &&
                                validarNombrePerfil(value)
                            ) {
                                setErrorSufijo("");
                            }

                        }}
                    />

                </Box>

                <Divider sx={{ my: 3 }} />

                <Box
                    display="flex"
                    justifyContent="flex-end"
                    gap={2}
                >

                    <Button
                        variant="contained"
                        onClick={cerrarModal}
                        sx={{
                            bgcolor: "#F70083",
                            color: "#fff",
                            fontWeight: 600,
                            textTransform: "none",
                            borderRadius: 2,
                            px: 3,
                            "&:hover": {
                                bgcolor: "#D60072",
                            },
                        }}
                    >
                        Cancelar
                    </Button>

                    <Button
                        variant="contained"
                        onClick={guardar}
                        disabled={
                            loading ||
                            !validarNombrePerfil(nombre) ||
                            !validarDescripcionPerfil(descripcion) ||
                            !validarNombrePerfil(sufijo)
                        }
                        sx={{
                            bgcolor: "#2e7d32",
                            color: "#fff",
                            fontWeight: 600,
                            textTransform: "none",
                            borderRadius: 2,
                            px: 3,
                            "&:hover": {
                                bgcolor: "#1b5e20",
                            },
                        }}
                    >
                        {
                            loading
                                ? "Guardando..."
                                : "Guardar Permiso"
                        }
                    </Button>

                </Box>

            </Box>

        </Modal>

    );

};

export default AddAdminPermiso;